import { useState, useCallback, useEffect, useRef, useMemo } from "react";
import ModalDownloadsCartao from './modal-downloads-cartao';
import InfiniteScroll from 'react-infinite-scroll-component';
import { IArquivoCardEsteira } from "../../interfaces/IArquivoCardEsteira";
import { IArquivoCard } from "../../interfaces/IArquivoCard";
import RelatoriosService from "../../services/RelatoriosService";
import Swal from "sweetalert2";
import ArquivoEmpresaService from "../../services/ArquivoEmpresaService";
import { uniqueId } from "lodash";
import { Modal } from 'react-bootstrap-v5';
import { IContaParticipante, IEntries, ILancamento, IRelatorio } from "../../interfaces/IRelatorio";
import cartaoNovaService from "../../services/cartaoNovaService";
import ReactS3Client from "react-aws-s3-typescript";
import { configBucket } from "../../utils/S3Utils";
import ParametrizacaoService from "../../services/ParametrizacaoService";
import moment from "moment";
import EmpresasService from "../../services/EmpresasService";
import ArquivoCardEsteiraService from "../../services/ArquivoCardEsteiraService";
import DropdownList from "react-widgets/DropdownList";
import { groupBy } from '../../utils/Array';
import ReactHtmlParser from 'react-html-parser';
import { HubConnection } from "@microsoft/signalr";
import ModalGerenciarLancamentos from "./modalGerenciarLancamentos";
import lancamentoNovaService from "../../services/lancamentoNovaService";
import ArquivosCartao from "./arquivos-cartao";
import AnexosCartao from "./anexos-cartao";
import ModalConciliadoBancario from "./modal-conciliado-bancario";
import ModalConciliadoFolha from "./modal-conciliado-folha";
import ModalIrrfFolhaAnalise from "./modal-irrf-folha-analise";
import ModalEstoqueAnalise from "./modal-estoque-analise";
import ModalFgtsAnalise from "./modal-fgts-analise";
import ModalSalarioLiquidoAnalise from "./modal-salario-liquido-analise";
import { useAuth } from "../../contexts/AuthProvider";
import { MapaRevisados, chaveRevisados, descartarRevisadosAlterados, desmarcarRevisado, grupoRevisado, lerRevisados, marcarRevisado, salvarRevisados } from "./conciliacaoRevisados";

/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';
import api from "../../services/Api";

const statusObject: any = {
    'possiveisMatch': "CONFIRMAÇÃO DE CONCILIAÇÕES",
    'erro': 'ERROS',
    'recomendacao': 'RECOMENDAÇÕES',
    'conciliacao': 'MATCH DE CONCILIAÇÕES',
    'pendente': 'PENDENTES DE CONCILIAÇÕES',
    'aviso': 'AVISOS',
    'conciliado': 'CONCILIADOS',
    'totalpendente': 'SOLICITAÇÕES DE ALTERAÇÃO',
}

const statusObjectCounter: any = {
    'erro': 'erros',
    'aviso': 'avisos',
    'conciliado': 'conciliados',
    'pendente': 'pendentesConciliacao',
    'conciliacao': 'matchesConciliacao',
    'recomendacao': 'recomendacoes',
    'possiveisMatch': 'possiveisMatch'
}

const tipoOperacaoMap: { [key: string]: string } = {
    'CONCILIATION': 'Conciliação',
    'MOVE_ALL': 'Mover todos',
};

function ModalConciliacao({ toggleModal, show, item }: { toggleModal: () => void, show: boolean, item: IEntries }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [possiveisMatch, setPossiveisMatch] = useState<ILancamento[]>([]);

    const onConciliar = useCallback((entry: ILancamento) => {
        EmpresasService.conciliarLancamentos([item.id, entry.id || 0], item.codigoContabil).then((resp) => {
            Swal.fire({
                text: t('Lançamentos conciliados com sucesso'),
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });

            toggleModal();
        });
    }, [item, toggleModal]);

    const buscarPossiveisMatch = useCallback((item) => {
        RelatoriosService.buscarPossivelMatch(item.id).then((resp) => {
            setPossiveisMatch(resp);
            setLoading(false);
            setLoaded(true);
        });
    }, [])

    useEffect(() => {
        console.log('aqui', item);
        if (!loaded && !loading) {
            setLoading(true);
            buscarPossiveisMatch(item);
        }
    }, [loading, item, buscarPossiveisMatch]);

    useEffect(() => {
        if (!show) {
            setLoaded(false);
        }
    }, [show])


    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-arrow-left" style={{ color: '#5E6397' }}></i>
                    </div>
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>{t("Conciliação Inteligente")}</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-12">
                            {loading && <label>{t("Carregando...")}</label>}
                            {(!possiveisMatch || possiveisMatch.length === 0) && !loading && (
                                <label>{t("Não foi encontrado nenhum lançamento")}</label>
                            )}
                            {possiveisMatch && possiveisMatch.length > 0 && !loading && (
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">{t("Conta")}</th>
                                            <th scope="col">{t("Descrição")}</th>
                                            <th scope="col">{t("Data")}</th>
                                            <th scope="col">{t("Valor")}</th>
                                            <th scope="col">{t("Histórico")}</th>
                                            <th scope="col">{t("Tipo Lançamento")}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {possiveisMatch.map((item) => (
                                            <tr key={uniqueId()}>
                                                <th>{item.codigoContabil}</th>
                                                <th>{item.descricaoCodigoContabil}</th>
                                                <th scope="row">{moment(item.dataLancamento).format('DD/MM/YYYY')}</th>
                                                <td>{item?.valorProvisaoRecolher?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>{item.historico}</td>
                                                <td>{item.tipoLancamento}</td>
                                                <td><button className="btn btn-danger" onClick={() => {
                                                    setLoading(true);
                                                    onConciliar(item);
                                                }}>{t("Conciliar")}</button></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

function RelatorioDemonstracaoContas({ contas, toggleModal, show, id, status, esteiraID }: { contas: IRelatorio[], toggleModal: () => void, show: boolean, id: number, status: string, esteiraID: number }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [modalAlterar, setModalAlterar] = useState<boolean>(false);
    const [item, setItem] = useState<IEntries[]>([]);
    const [data, setData] = useState<IEntries[]>([]);
    const [lancamentosSelecionados, setLancamentosSelecionados] = useState<number[]>([]);
    const [lancamentosPendentes, setLancamentosPendentes] = useState<Set<number>>(new Set());

    const loadData = useCallback((offset) => {
        RelatoriosService.dadosResumidosPorStatusInterno(esteiraID, id, offset, status === "conciliacao" ? "totalpendente" : status, '', false, (result) => {
            setData((old) => {
                if (offset > 0) {
                    const oldObjFake = old || [];
                    const oldObj = [...oldObjFake];
                    return oldObj.concat(result);
                }

                return result;
            });

            if (result && result.length > 0) {
                setTimeout(() => {
                    loadData(offset + result.length);
                }, 2000)
            } else {
                setLoading(false);
            }
        });
    }, [esteiraID, id, status]);

    const carregarPendentes = useCallback(() => {
        if (status !== 'totalpendente') return;
        ArquivoCardEsteiraService.buscarAlteracoesPendentesNova(esteiraID)
            .then((pendentes) => setLancamentosPendentes(new Set(pendentes.map(p => p.lancamentoId))))
            .catch(() => setLancamentosPendentes(new Set()));
    }, [esteiraID, status]);

    const onSelect = useCallback((e: any, acc: number[]) => {
        if (e) {
            setLancamentosSelecionados((old) => {
                const cp = [...old];
                acc.forEach(f => {
                    if (!cp.includes(f)) {
                        cp.push(f);
                    }
                });

                return cp;
            })
        } else {
            setLancamentosSelecionados((old) => {
                return old.filter(item => !acc.includes(item));
            });
        }
    }, []);

    const onAlterar = useCallback((item: IEntries) => {
        setItem([item]);
        setModalAlterar(true);
    }, []);

    const onAlterarSelecionados = useCallback(() => {
        const itens = data.filter(i => lancamentosSelecionados.includes(i.id));
        setItem(itens);
        setModalAlterar(true);
    }, [data, lancamentosSelecionados]);

    const onBuscarLancamentos = useCallback((item: IEntries) => {
        setItem([item]);
        setModalAlterar(true);
    }, []);

    const onDesvincularStatus = useCallback((id) => {
        setLoading(true);
        Swal.fire({
            title: t('Deseja desvincular o status ?'),
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await lancamentoNovaService.desvincularStatus(id);
                    Swal.fire({
                        text: t('Status desvinculado com sucesso.'),
                        timer: 3000,
                        icon: 'success',
                        showConfirmButton: false
                    });
                    setData((old) => {
                        const copy = [...old];
                        return copy.filter(f => f.id !== id);
                    });
                } catch (e: any) {
                    Swal.fire({
                        text: t('Ocorreu um erro inesperado.'),
                        timer: 3000,
                        icon: 'error',
                        showConfirmButton: false
                    });
                }
                setLoading(false);
            } else {
                setLoading(false);
            }
        });

    }, [loadData, id]);

    useEffect(() => {
        if (show) {
            setData([]);
            setLoading(true);
            loadData(0);
            carregarPendentes();
        }
    }, [show, loadData, carregarPendentes]);

    return (
        <>
            <Modal scrollable size={status === 'totalpendente' ? 'xl' : 'lg'} centered={true} show={!show || modalAlterar ? false : true} onHide={toggleModal}>
                <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                    <div className="modal-header">
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <i onClick={toggleModal} className="fas fa-arrow-left" style={{ color: '#5E6397' }}></i>
                        </div>
                        <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>{statusObject[status]}</h5>
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="row g-3">
                            {data && data.length > 0 && (
                                <div className="col-12 d-flex align-items-center justify-content-between">
                                    <span className="text-muted fs-7">
                                        {data.length} {t("lançamento(s) encontrado(s)")}
                                    </span>
                                </div>
                            )}

                            {data && data.length > 0 && !loading && status === 'totalpendente' && (
                                <div className="col-12">
                                    <div className="d-flex align-items-center gap-3 p-3 bg-light rounded">
                                        <div className="form-check mb-0">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="selectAll"
                                                checked={data.length === lancamentosSelecionados.length && data.length > 0}
                                                onChange={(e) => onSelect(e.target.checked, data.map(i => i.id))}
                                            />
                                            <label className="form-check-label fw-semibold" htmlFor="selectAll">
                                                {t("Selecionar todos")}
                                            </label>
                                        </div>
                                        {lancamentosSelecionados.length > 0 && (
                                            <>
                                                <span className="badge badge-light-primary fs-7">
                                                    {lancamentosSelecionados.length} {t("selecionado(s)")}
                                                </span>
                                                <button
                                                    onClick={onAlterarSelecionados}
                                                    type='button'
                                                    className="btn btn-sm btn-primary"
                                                >
                                                    <i className="fas fa-edit me-1" />
                                                    {t("Solicitar Alteração em Massa")}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div className="col-12">
                                {loading && (
                                    <div className="d-flex align-items-center gap-2 text-muted py-4 justify-content-center">
                                        <span className="spinner-border spinner-border-sm" />
                                        <span>{t("Carregando lançamentos...")}</span>
                                    </div>
                                )}
                                {(!data || data.length === 0) && !loading && (
                                    <div className="text-center text-muted py-8">
                                        <i className="fas fa-inbox fs-2x mb-3 d-block opacity-50" />
                                        <span>{t("Nenhum lançamento encontrado")}</span>
                                    </div>
                                )}
                                {data.length > 0 && (
                                    <table className="table table-hover table-sm align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                {status === 'totalpendente' && <th style={{ width: 40 }}></th>}
                                                {status === "conciliacao" && <th scope="col">{t("Conta")}</th>}
                                                <th scope="col">{t("Data")}</th>
                                                <th scope="col">{t("Valor")}</th>
                                                <th scope="col">{t("Histórico")}</th>
                                                <th scope="col">{t("Tipo")}</th>
                                                {(status === "erro" || status === "aviso" || status === "recomendacao" || status === "pendente") && (
                                                    <>
                                                        <th scope="col">{t("Erro")}</th>
                                                        <th scope="col">{t("Recomendação")}</th>
                                                    </>
                                                )}
                                                {status === "conciliado" && (
                                                    <th scope="col">{t("Chave Vínculo")}</th>
                                                )}
                                                {(status === "totalpendente" || status === "conciliacao") && (
                                                    <th style={{ width: 160 }}></th>
                                                )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((item) => (
                                                <tr key={uniqueId()}>
                                                    {status === 'totalpendente' && (
                                                        <td>
                                                            <div className="form-check d-flex justify-content-center mb-0">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={lancamentosSelecionados.includes(item.id)}
                                                                    onChange={(e) => onSelect(e.target.checked, [item.id])}
                                                                />
                                                            </div>
                                                        </td>
                                                    )}
                                                    {status === "conciliacao" && <td>{item.codigoContabil}</td>}
                                                    <td className="text-nowrap">{moment(item.dataLancamento).format('DD/MM/YYYY')}</td>
                                                    <td className="text-nowrap fw-semibold">{item.valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                    <td className="text-truncate" style={{ maxWidth: 200 }} title={item.historico}>{item.historico}</td>
                                                    <td><span className="badge badge-light-info">{item.tipoLancamento}</span></td>
                                                    {(status === "erro" || status === "aviso" || status === "recomendacao" || status === "pendente") && (
                                                        <>
                                                            <td>{item.mensagem && item.mensagem.descricaoMensagem}</td>
                                                            <td>{item.mensagem && item.mensagem.recomendacaoAjuste}</td>
                                                        </>
                                                    )}
                                                    {status === "conciliado" && (
                                                        <td>{item.chaveVinculo}</td>
                                                    )}
                                                    {status === "totalpendente" && (
                                                        <td>
                                                            {item.status === 'PENDENTESALDOANTERIOR' ? (
                                                                <button onClick={() => onDesvincularStatus(item.id)} type='button' className="btn btn-sm btn-light-warning">
                                                                    <i className="fas fa-unlink me-1" />
                                                                    {t("Desvincular")}
                                                                </button>
                                                            ) : lancamentosPendentes.has(item.id) ? (
                                                                <span title={t("Já existe uma alteração aguardando aprovação para este lançamento")}>
                                                                    <button type='button' className="btn btn-sm btn-secondary" disabled>
                                                                        <i className="fas fa-clock me-1" />
                                                                        {t("Aguardando aprovação")}
                                                                    </button>
                                                                </span>
                                                            ) : (
                                                                <button onClick={() => onAlterar(item)} type='button' className="btn btn-sm btn-light-primary">
                                                                    <i className="fas fa-edit me-1" />
                                                                    {t("Solicitar Alteração")}
                                                                </button>
                                                            )}
                                                        </td>
                                                    )}
                                                    {status === "conciliacao" && (
                                                        <td>
                                                            <button className="btn btn-sm btn-light-primary" onClick={() => onBuscarLancamentos(item)}>
                                                                <i className="fas fa-search me-1" />
                                                                {t("Buscar")}
                                                            </button>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {item.length > 0 && status !== "conciliacao" && (
                <ModalAlterarLancamento esteiraID={esteiraID} contas={contas} show={modalAlterar} item={item} toggleModal={() => {
                    setModalAlterar(false);
                    setLoading(true);
                    loadData(0);
                    carregarPendentes();
                }} />
            )}
            {item.length > 0 && status === "conciliacao" && (
                <ModalConciliacao show={modalAlterar} item={item[0]} toggleModal={() => {
                    setModalAlterar(false);
                    setLoading(true);
                    loadData(0);
                }} />
            )}
        </>
    )
}



function ModalAlterarLancamento({ contas, esteiraID, toggleModal, show, item }: { esteiraID: number, contas: IRelatorio[], toggleModal: () => void, show: boolean, item: IEntries[] }) {
    const { t } = useTranslation();
    const isBulk = item.length > 1;
    const [tipo, setTipo] = useState<string>(isBulk ? 'CONTA' : '');
    const [contaSelecionada, setContaSelecionada] = useState<string>('');
    const [carregandoContas, setCarregandoContas] = useState<boolean>(false);
    const [dadosContas, setDadosContas] = useState<IRelatorio[]>([]);
    const [textoHistorico, setTextoHistorico] = useState<string>(item[0].historico);
    const [valor, setValor] = useState<string>(item[0].valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "").trim());

    const onSubmit = useCallback(async () => {
        if (!tipo) return;

        try {
            switch (tipo) {
                case 'HISTORICO':
                    if (!textoHistorico) {
                        Swal.fire({ text: t('Por favor forneça um novo histórico'), timer: 3000, icon: 'error', showConfirmButton: false });
                        return;
                    }
                    if (item[0].historico === textoHistorico) {
                        Swal.fire({ text: t('Para alterar o histórico é necessário que ele seja diferente do histórico anterior'), timer: 3000, icon: 'error', showConfirmButton: false });
                        return;
                    }
                    await ArquivoCardEsteiraService.alterarHistorico(item[0].id, textoHistorico, esteiraID);
                    break;

                case 'VALOR': {
                    if (!valor) {
                        Swal.fire({ text: t('Por favor digite um novo valor'), timer: 3000, icon: 'error', showConfirmButton: false });
                        return;
                    }
                    const valorLimpo = valor.replace(".", "").replace(",", ".");
                    const novoValor = Number(valorLimpo);
                    if (item[0].valorProvisaoRecolher === novoValor) {
                        Swal.fire({ text: t('Para alterar o valor é necessário que ele seja diferente do valor anterior'), timer: 3000, icon: 'error', showConfirmButton: false });
                        return;
                    }
                    await ArquivoCardEsteiraService.alterarValor(item[0].id, valorLimpo, esteiraID);
                    break;
                }

                case 'CONTA':
                    if (!contaSelecionada) {
                        Swal.fire({ text: t('Para alterar a conta é necessário selecionar uma opção.'), timer: 3000, icon: 'error', showConfirmButton: false });
                        return;
                    }
                    if (isBulk) {
                        await ArquivoCardEsteiraService.solicitarAlteracaoLote(esteiraID, item.map(i => i.id), contaSelecionada);
                    } else {
                        await ArquivoCardEsteiraService.alterarConta([{ lancamentoID: item[0].id, conta: contaSelecionada, esteiraId: esteiraID }]);
                    }
                    break;

                case 'ESTORNO':
                    await ArquivoCardEsteiraService.alterarEstorno(item[0].id, esteiraID);
                    break;

                default:
                    return;
            }

            Swal.fire({ text: t('Inserimos sua solicitação para aprovação do fiscal contábil, após aprovada suas alterações serão refletidas em seu lançamento'), timer: 3000, icon: 'success', showConfirmButton: false });
            toggleModal();
        } catch (e: any) {
            const msg = e?.response?.data?.message || e?.message || t('Ocorreu um erro ao processar a solicitação.');
            Swal.fire({ text: msg, timer: 5000, icon: 'error', showConfirmButton: false });
        }
    }, [tipo, textoHistorico, valor, contaSelecionada, item, esteiraID, isBulk, toggleModal]);

    useEffect(() => {
        setValor(item[0].valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "").trim());
        setTextoHistorico(item[0].historico);
        setContaSelecionada('');
        setTipo(isBulk ? 'CONTA' : '');
    }, [item, isBulk]);

    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>{t("Ajuste de Lançamento")}{isBulk ? 's' : ''}</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {!isBulk && (
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>{t("Tipo de alteração")}</label>
                                    <select className="form-control mt-1" value={tipo} onChange={(e) => { setTipo(e.target.value); setContaSelecionada(''); }}>
                                        <option value="">{t("Selecione um tipo...")}</option>
                                        <option value="CONTA">{t("Conta")}</option>
                                        <option value="HISTORICO">{t("Histórico")}</option>
                                        <option value="VALOR">{t("Valor")}</option>
                                        <option value="ESTORNO">{t("Estorno")}</option>
                                    </select>
                                </div>
                            </div>
                        )}

                        <div className="col-md-12 mt-2">
                            <div className="form-group">
                                <label>{t("Conta de destino")}</label>
                                <DropdownList
                                    disabled={tipo !== 'CONTA'}
                                    onSearch={async (e) => {
                                        if (tipo !== 'CONTA') return;
                                        if (e && e.length > 0) {
                                            setCarregandoContas(true);
                                            const result: IRelatorio[] = [];
                                            const resp = await RelatoriosService.buscarCartaoPorFiltroCorreto(esteiraID, e, false);
                                            resp.forEach((item) => result.push(item));
                                            const resp2 = await RelatoriosService.buscarCartaoPorFiltroCorreto(esteiraID, e, true);
                                            resp2.forEach((item) => result.push(item));
                                            setDadosContas(result);
                                            setCarregandoContas(false);
                                        }
                                    }}
                                    filter={() => true}
                                    delay={2000}
                                    busy={carregandoContas}
                                    data={dadosContas.filter(f => f.contaEmpresa !== contaSelecionada).map((item) => `${item.contaEmpresa} - ${item.descricaoEmpresa}`)}
                                    onChange={(e) => setContaSelecionada(e.split('-')[0].trim())}
                                />
                            </div>
                        </div>

                        {!isBulk && (
                            <>
                                <div className="col-md-12 mt-2">
                                    <div className="form-group">
                                        <label>{t("Novo histórico")}</label>
                                        <input
                                            className='form-control mt-1'
                                            value={textoHistorico}
                                            onChange={(e) => setTextoHistorico(e.target.value)}
                                            disabled={tipo !== 'HISTORICO'}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12 mt-2">
                                    <div className="form-group">
                                        <label>{t("Novo valor")}</label>
                                        <input
                                            className='form-control mt-1'
                                            type="text"
                                            value={valor}
                                            disabled={tipo !== 'VALOR'}
                                            onChange={(e) => {
                                                if (tipo !== 'VALOR') return;
                                                let value = e.target.value;
                                                if (!value) {
                                                    setValor(Number(0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "").trim());
                                                } else {
                                                    value = parseInt(value.replace(/[\D]+/g, '')).toString();
                                                    value = value.replace(/([0-9]{2})$/g, ",$1");
                                                    if (value.length > 6) {
                                                        value = value.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
                                                    }
                                                    setValor(value);
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="col-md-12 mt-4">
                            <button type="button" onClick={onSubmit} disabled={!tipo} className="btn btn-success">{t("SOLICITAR")}</button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}


function RelatorioDemonstracaoContasConfirmacao({ id, connection, toggleModal, show, acc, esteiraID, onAceitarTodos, onRecusarTodos }: { id: number, toggleModal: () => void, show: boolean, acc: string, esteiraID: number, connection: HubConnection, onAceitarTodos?: () => void, onRecusarTodos?: () => void }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<IEntries[]>([]);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [carregandoMais, setCarregandoMais] = useState<boolean>(false);
    const { usuario } = useAuth();
    const [revisados, setRevisados] = useState<MapaRevisados>({});
    const [mostrarRevisados, setMostrarRevisados] = useState<boolean>(false);
    const scrollRef = useRef<HTMLDivElement>(null);
    const chaveStorage = usuario?.id ? chaveRevisados(usuario.id, esteiraID, id) : null;

    const grupos: Record<string, IEntries[]> = useMemo(() => groupBy(data, 'chaveVinculoMatch'), [data]);
    const chavesGrupos = Object.keys(grupos);
    const chavesRevisadas = chavesGrupos.filter(chave => grupoRevisado(revisados, chave, grupos[chave].map(i => i.id)));
    const chavesVisiveis = mostrarRevisados ? chavesGrupos : chavesGrupos.filter(chave => !chavesRevisadas.includes(chave));

    const atualizarRevisados = useCallback((fn: (mapa: MapaRevisados) => MapaRevisados) => {
        setRevisados((old) => {
            const novo = fn(old);
            if (novo !== old && chaveStorage) {
                salvarRevisados(chaveStorage, novo);
            }
            return novo;
        });
    }, [chaveStorage]);

    // Remove os grupos concluídos da lista sem recarregar a modal e devolve a rolagem para onde o
    // usuário estava (DEVN3-607) — o próximo grupo ocupa o lugar do que saiu.
    const removerGruposDaLista = useCallback((chaves: string[], scrollTop: number) => {
        setData((old) => old.filter(i => !chaves.includes(i.chaveVinculoMatch || '')));
        atualizarRevisados((mapa) => chaves.reduce((m, chave) => desmarcarRevisado(m, chave), mapa));
        requestAnimationFrame(() => {
            if (scrollRef.current) scrollRef.current.scrollTop = scrollTop;
        });
    }, [atualizarRevisados]);

    const loadData = useCallback((offset) => {
        RelatoriosService.dadosResumidosPorStatusInterno(esteiraID, id, offset, 'totalmatch', '', false, (result) => {
            if (!result || result.length <= 0) {
                setHasMore(false);
            } else {
                setHasMore(true);
            }

            setData((old) => {
                if (offset > 0) {
                    const oldObjFake = old || [];
                    const oldObj = [...oldObjFake];
                    return oldObj.concat(result);
                }

                return result;
            });


            setLoading(false);
            setCarregandoMais(false);
        });
    }, [esteiraID, id]);

    const onToggleRevisado = useCallback((chaveVinculo: string, ids: number[], marcar: boolean) => {
        atualizarRevisados((mapa) => marcar ? marcarRevisado(mapa, chaveVinculo, ids) : desmarcarRevisado(mapa, chaveVinculo));
    }, [atualizarRevisados]);

    const onClickRecusarMatch = useCallback((chaveVinculo?: string) => {
        const scrollTop = scrollRef.current?.scrollTop ?? 0;
        if (chaveVinculo) {
            Swal.fire({
                title: t('Você gostaria de recusar a conciliação ?'),
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
                confirmButtonText: 'Sim',
                denyButtonText: `Não`,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await ParametrizacaoService.desvincularMatch(id, chaveVinculo);
                    removerGruposDaLista([chaveVinculo], scrollTop);
                }
            });
        } else {
            Swal.fire({
                title: t('Você gostaria de recusar todas as conciliações ?'),
                text: t('Inclui os grupos marcados como revisados.'),
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
                confirmButtonText: 'Sim',
                denyButtonText: `Não`,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setLoading(true);
                    await api.patch(`Conciliation/card/${id}/refuse/match`);
                    onRecusarTodos?.();
                    Swal.fire({
                        text: t('Estamos processando a recusa das conciliações.'),
                        timer: 3000,
                        icon: 'success',
                        showConfirmButton: false
                    });
                }
            });
        }
    }, [esteiraID, acc, id, removerGruposDaLista]);

    const onClickDesvincularItemMatch = useCallback((chaveVinculo: string, lancamentoId: number) => {
        const scrollTop = scrollRef.current?.scrollTop ?? 0;
        Swal.fire({
            title: t('Você gostaria de desvincular o item ?'),
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                setData((old) => {
                    const copy = [...old];
                    return copy.filter((item) => item.id !== lancamentoId);
                });
                requestAnimationFrame(() => {
                    if (scrollRef.current) scrollRef.current.scrollTop = scrollTop;
                });
                await ParametrizacaoService.desvincularItemMatch(id, lancamentoId);
            }
        });
    }, [esteiraID, acc, id]);

    const onClickAceitar = useCallback((chaveVinculo?: string) => {
        const scrollTop = scrollRef.current?.scrollTop ?? 0;
        if (chaveVinculo) {
            Swal.fire({
                title: t('Você aceita a conciliação ?'),
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
                confirmButtonText: 'Sim',
                denyButtonText: `Não`,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await ParametrizacaoService.vincularMatch(id, chaveVinculo);
                    removerGruposDaLista([chaveVinculo], scrollTop);
                }
            });
        } else {
            Swal.fire({
                title: t('Você aceita conciliar todos ?'),
                text: t('Inclui os grupos marcados como revisados.'),
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
                confirmButtonText: 'Sim',
                denyButtonText: `Não`,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setLoading(true);
                    await api.patch(`Conciliation/card/${id}/accept/match`);
                    onAceitarTodos?.();
                    Swal.fire({
                        text: t('Estamos processando suas conciliações aprovadas.'),
                        timer: 3000,
                        icon: 'success',
                        showConfirmButton: false
                    });
                }
            });
        }
    }, [esteiraID, acc, toggleModal, id, removerGruposDaLista]);

    // DEVN3-613: aceita em lote só os grupos marcados como "Revisado" (e com a composição inalterada —
    // chavesRevisadas já aplica a assinatura). Mesma operação do "Aceitar Todos" no Worker, filtrada pelas chaves.
    const onClickAceitarRevisados = useCallback(() => {
        const chaves = [...chavesRevisadas];
        if (chaves.length === 0) return;

        Swal.fire({
            title: t('Você aceita conciliar {{quantidade}} grupo(s) revisado(s) ?', { quantidade: chaves.length }),
            text: t('Os grupos não revisados continuam pendentes.'),
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then(async (result) => {
            if (!result.isConfirmed) return;

            try {
                setLoading(true);
                await api.patch(`Conciliation/card/${id}/accept/match/revisados`, chaves);
                atualizarRevisados((mapa) => chaves.reduce((m, chave) => desmarcarRevisado(m, chave), mapa));
                onAceitarTodos?.();
                Swal.fire({
                    text: t('Estamos processando as conciliações revisadas.'),
                    timer: 3000,
                    icon: 'success',
                    showConfirmButton: false
                });
            } catch (error: any) {
                setLoading(false);
                Swal.fire({
                    text: error?.response?.data?.message || error?.message || t('Não foi possível aceitar os grupos revisados.'),
                    icon: error?.response?.status === 409 ? 'warning' : 'error',
                });
            }
        });
    }, [chavesRevisadas, id, atualizarRevisados, onAceitarTodos]);


    useEffect(() => {
        if (show) {
            setLoading(true);
            loadData(0);
        }
    }, [show, loadData, esteiraID]);

    useEffect(() => {
        if (show && chaveStorage) {
            setRevisados(lerRevisados(chaveStorage));
        }
        if (!show) {
            setMostrarRevisados(false);
        }
    }, [show, chaveStorage]);

    // Grupo revisado cuja composição mudou (item removido, motor recalculou) volta a aparecer.
    useEffect(() => {
        const idsPorGrupo: Record<string, number[]> = {};
        Object.keys(grupos).forEach(chave => { idsPorGrupo[chave] = grupos[chave].map(i => i.id); });
        atualizarRevisados((mapa) => descartarRevisadosAlterados(mapa, idsPorGrupo));
    }, [grupos, atualizarRevisados]);

    useEffect(() => {
        if (connection) {
            connection.on("FinalizouProcessamento", (args) => {
                const data = JSON.parse(args);
                if (data.EsteiraID === esteiraID) {
                    Swal.fire({
                        text: t('Todos lançamentos foram aprovados com sucesso.'),
                        timer: 3000,
                        icon: 'success',
                        showConfirmButton: false
                    });
                    setData([]);
                    setLoading(false);
                }
            });
        }
    }, [connection, esteiraID]);

    return (
        <Modal size='xl' centered={true} show={show} onHide={toggleModal} scrollable>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>{t('Confirmação de Conciliação')}</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body" id="scrollableDiv" ref={scrollRef}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                        <i className="fa fa-search" style={{ color: '#6c757d', flexShrink: 0 }} />
                        <input className="form-control" type="text" placeholder={t('Filtre por histórico, valor ou data')} style={{ flex: 1 }} />
                        <button className="btn btn-primary" style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 600 }}>
                            <i className="fa fa-search" />
                            {t("Pesquisar")}
                        </button>
                    </div>
                    <InfiniteScroll
                        style={{ overflow: 'hidden' }}
                        dataLength={chavesGrupos.length}
                        next={() => loadData(chavesGrupos.length)}
                        hasMore={hasMore}
                        scrollableTarget={'scrollableDiv'}
                        loader={<div className='col-md-12 mt-2'>
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                {t("Aguarde...")}
                            </span>
                        </div>}
                        endMessage={
                            <p style={{ textAlign: 'center' }}>
                                <b>{t("Todos os lançamentos foram carregados")}</b>
                            </p>
                        }
                        refreshFunction={() => { }}
                        pullDownToRefresh
                        pullDownToRefreshThreshold={50}
                    >
                        <div className="row">
                            {data && data.length > 0 && !loading && (
                                <div className='col-md-12 mb-3'>
                                    <div style={{ display: 'flex', gap: '10px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                                        <button type="button" onClick={() => onClickAceitar()} className="btn btn-success" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontWeight: 600 }}>
                                            <i className="fa fa-check-circle" />
                                            {t("Aceitar Todos")}
                                        </button>
                                        {chavesRevisadas.length > 0 && (
                                            <button type="button" onClick={onClickAceitarRevisados} className="btn btn-outline btn-outline-success" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontWeight: 600 }}>
                                                <i className="fa fa-check-double" />
                                                {t("Aceitar Revisados")} ({chavesRevisadas.length})
                                            </button>
                                        )}
                                        <button type="button" onClick={() => onClickRecusarMatch()} className="btn btn-danger" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontWeight: 600 }}>
                                            <i className="fa fa-times-circle" />
                                            {t("Recusar Todos")}
                                        </button>
                                    </div>
                                    {chavesRevisadas.length > 0 && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px', fontSize: '13px', color: '#6c757d' }}>
                                            <span>
                                                <i className="fa fa-eye-slash me-1" />
                                                {chavesRevisadas.length} {t("grupo(s) revisado(s)")}
                                            </span>
                                            <div className="form-check form-switch mb-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="mostrarRevisados"
                                                    checked={mostrarRevisados}
                                                    onChange={(e) => setMostrarRevisados(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="mostrarRevisados">{t("Mostrar revisados")}</label>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="col-md-12">
                                {loading && <label>{t("Carregando...")}</label>}
                                {(!data || data.length === 0) && !loading && (
                                    <label>{t("Não foi encontrado nenhum lançamento")}</label>
                                )}
                                {data && data.length > 0 && !loading && (
                                    <>
                                        {chavesVisiveis.map((item) => {
                                            const groupItems = grupos[item];
                                            const revisado = chavesRevisadas.includes(item);
                                            const totalDebito = groupItems.filter(f => f.tipoLancamento === 'D').reduce((a, b) => a + b.valorProvisaoRecolher, 0);
                                            const totalCredito = groupItems.filter(f => f.tipoLancamento === 'C').reduce((a, b) => a + b.valorProvisaoRecolher, 0);
                                            const diferenca = Math.abs(totalCredito - totalDebito);
                                            return (
                                                <div key={item} style={{ marginBottom: '12px', border: '1px solid #e9ecef', borderRadius: '8px', overflow: 'hidden', opacity: revisado ? 0.55 : 1 }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 14px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #e9ecef' }}>
                                                        <span style={{ fontWeight: 600, fontSize: '13px', color: '#495057' }}>
                                                            <i className="fa fa-link me-2" style={{ color: '#6c757d' }} />
                                                            {t("Grupo de conciliação")}
                                                        </span>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <div className="form-check mb-0 me-2" title={t("Oculta este grupo enquanto você revisa os demais. Fica salvo neste navegador.")}>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`revisado-${item}`}
                                                                    checked={revisado}
                                                                    onChange={(e) => onToggleRevisado(item, groupItems.map(i => i.id), e.target.checked)}
                                                                />
                                                                <label className="form-check-label" htmlFor={`revisado-${item}`} style={{ fontSize: '13px' }}>{t("Revisado")}</label>
                                                            </div>
                                                            {groupItems.length > 1 && (
                                                                <button type="button" onClick={() => onClickAceitar(item)} className="btn btn-success btn-sm" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                    <i className="fa fa-check" />{t("Aceitar")}
                                                                </button>
                                                            )}
                                                            <button type="button" onClick={() => onClickRecusarMatch(item)} className="btn btn-danger btn-sm" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                <i className="fa fa-times" />{t("Recusar")}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <table className="table table-sm mb-0">
                                                        <thead style={{ backgroundColor: '#f0f0f0' }}>
                                                            <tr>
                                                                <th style={{ width: '48px' }}></th>
                                                                <th>{t("Data")}</th>
                                                                <th>{t("Conta")}</th>
                                                                <th>{t("Histórico")}</th>
                                                                <th>{t("Tipo")}</th>
                                                                <th>{t("Valor")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {groupItems.map((item2) => (
                                                                <tr key={item2.id}>
                                                                    <td>
                                                                        <button type="button" disabled={groupItems.length <= 2} onClick={() => onClickDesvincularItemMatch(item2.chaveVinculoMatch || '', item2.id)} className="btn btn-outline-danger btn-sm" title={t("Remover")}>
                                                                            <i className="fa fa-trash" />
                                                                        </button>
                                                                    </td>
                                                                    <td style={{ whiteSpace: 'nowrap' }}>{moment(item2.dataLancamento).format('DD/MM/YYYY')}</td>
                                                                    <td style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item2.codigoContabil} - {item2.descricaoCodigoContabil}</td>
                                                                    <td title={item2.historico} style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'default' }}>{item2.historico}</td>
                                                                    <td><span className={`badge ${item2.tipoLancamento === 'D' ? 'bg-danger' : 'bg-success'}`}>{item2.tipoLancamento}</span></td>
                                                                    <td style={{ fontWeight: 500, whiteSpace: 'nowrap' }}>{item2.valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <div style={{ display: 'flex', gap: '24px', padding: '8px 14px', backgroundColor: '#f8f9fa', borderTop: '1px solid #e9ecef', fontSize: '13px' }}>
                                                        <span><strong>{t("Débito:")}</strong> {totalDebito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                                                        <span><strong>{t("Crédito:")}</strong> {totalCredito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                                                        <span style={{ color: diferenca === 0 ? '#198754' : '#dc3545' }}>
                                                            <strong>{t("Diferença:")}</strong> {diferenca.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {chavesVisiveis.length === 0 && (
                                            <p style={{ textAlign: 'center', color: '#6c757d', margin: '16px 0' }}>
                                                <i className="fa fa-check-double me-2" />
                                                {t("Todos os grupos carregados foram revisados.")}
                                            </p>
                                        )}
                                        {/* Com grupos ocultos a lista pode não ter rolagem suficiente para o InfiniteScroll disparar. */}
                                        {hasMore && chavesRevisadas.length > 0 && !mostrarRevisados && (
                                            <div style={{ textAlign: 'center', marginBottom: '8px' }}>
                                                <button type="button" className="btn btn-sm btn-light-primary" disabled={carregandoMais} onClick={() => {
                                                    setCarregandoMais(true);
                                                    loadData(chavesGrupos.length);
                                                }}>
                                                    {carregandoMais ? t("Aguarde...") : t("Carregar mais grupos")}
                                                </button>
                                            </div>
                                        )}
                                        <p style={{ fontSize: '13px', color: '#6c757d', marginTop: '8px' }}>{t("Total")}: {data.length} {t("lançamentos")}</p>
                                    </>
                                )}
                            </div>
                        </div>
                    </InfiniteScroll>
                </div>
            </div>
        </Modal >
    )
}

function RelatorioDemonstracaoContasConciliadas({ id, toggleModal, show, acc, esteiraID, isSalario }: { id: number, toggleModal: () => void, show: boolean, acc: string, esteiraID: number, isSalario: boolean }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<IEntries[]>([]);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [somenteDiferencas, setSomenteDiferencas] = useState<boolean>(false);
    const [filtro, setFiltro] = useState('');


    const loadData = useCallback((offset) => {
        RelatoriosService.dadosResumidosPorStatusInterno(esteiraID, id, offset, 'conciliado', filtro, somenteDiferencas, (result) => {

            if (!result || result.length <= 0) {
                setHasMore(false);
            } else {
                setHasMore(true);
            }

            setData((old) => {
                if (offset > 0) {
                    const oldObjFake = old || [];
                    const oldObj = [...oldObjFake];
                    return oldObj.concat(result);
                }

                return result;
            });

            setLoading(false);
        });
    }, [esteiraID, id, filtro, somenteDiferencas]);

    const onClickDesvincularTodos = useCallback((chaves: String[]) => {
        Swal.fire({
            title: t('Você gostaria de desvincular todos lançamentos ?'),
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                await ParametrizacaoService.manutencaoTodos(id);
                loadData(0);
                setLoading(false);
            }
        });
    }, [esteiraID, acc, id]);

    const onClickDesvincularItem = useCallback((chaveVinculo: string, lancamentoId: number) => {
        Swal.fire({
            title: t('Você gostaria de desvincular o item da conciliação ?'),
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                setData((old) => {
                    const copy = [...old];
                    return copy.filter((item) => item.id !== lancamentoId);
                });
                await ParametrizacaoService.desvincularItem(id, lancamentoId);
            }
        });
    }, [esteiraID, acc, id]);


    const onClickDesvincular = useCallback((chaveVinculo: string) => {
        Swal.fire({
            title: t('Você gostaria de desvincular a conciliação ?'),
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                await ParametrizacaoService.desvincular(id, chaveVinculo);
                setData((old) => {
                    const copy = [...old];
                    return copy.filter((item) => item.chaveVinculo !== chaveVinculo);
                });
            }
        });
    }, [esteiraID, acc, id]);

    useEffect(() => {
        if (show) {
            setLoading(true);
            loadData(0);
        }
    }, [show, loadData]);

    const onFilter = useCallback(() => {
        if (filtro || somenteDiferencas) {
            setLoading(true);
            RelatoriosService.dadosResumidosPorStatusInterno(esteiraID, id, 0, 'conciliado', filtro, somenteDiferencas, (result) => {
                setHasMore(false);
                setData(result);
                setLoading(false);
            });
        } else {
            loadData(0)
        }
    }, [filtro, esteiraID, id, loadData, somenteDiferencas]);

    const grupos = Object.keys(groupBy(data, 'chaveVinculo')).filter(k => k && k !== 'null');

    // DEVN3-638: na Hospedagem em Curso cada item indica de onde vem (contabilidade ou borderô do VHF).
    const isHospedagemEmCurso = String((acc as any)?.descricaoEmpresa ?? '').toLowerCase().includes('hospedagem em curso');

    return (
        <Modal size='xl' centered={true} show={show} onHide={toggleModal} scrollable>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>

                {/* Cabeçalho */}
                <div className="modal-header border-0 pb-1">
                    <div>
                        <h5 className="modal-title fw-bold mb-0" style={{ textTransform: 'uppercase', color: '#5E6397' }}>
                            {t("Conciliados")}
                        </h5>
                        {!loading && data.length > 0 && (
                            <small className="text-muted">
                                {grupos.length} {t("grupos")} &middot; {data.length} {t("lançamentos")}
                            </small>
                        )}
                    </div>
                    <button className="btn btn-icon btn-sm btn-active-light-primary ms-2" onClick={toggleModal}>
                        <i className="fas fa-times" style={{ color: '#5E6397' }} />
                    </button>
                </div>

                {/* Barra de ferramentas */}
                <div className="px-4 py-3 border-bottom d-flex flex-wrap gap-2 align-items-center" style={{ backgroundColor: '#fff' }}>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{ maxWidth: 280 }}
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                        placeholder={t("Filtrar por data, histórico ou valor...")}
                    />
                    <div className="form-check mb-0">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={somenteDiferencas}
                            id="somenteDiferencasConciliados"
                            onChange={(e) => setSomenteDiferencas(e.target.checked)}
                        />
                        <label className="form-check-label text-nowrap" htmlFor="somenteDiferencasConciliados">
                            {t("Somente diferenças")}
                        </label>
                    </div>
                    <button onClick={onFilter} disabled={loading} className="btn btn-primary btn-sm">
                        <i className="fas fa-search me-1" />{t("Filtrar")}
                    </button>
                    <div className="ms-auto d-flex gap-2">
                        {!loading && data.length > 0 && (
                            <button
                                type="button"
                                onClick={() => onClickDesvincularTodos(grupos)}
                                className="btn btn-outline-danger btn-sm"
                            >
                                <i className="fas fa-unlink me-1" />{t("Desvincular Todos")}
                            </button>
                        )}
                    </div>
                </div>

                {/* Corpo */}
                <div className="modal-body p-3" id="scrollableDiv">

                    {/* Carregando */}
                    {loading && (
                        <div className="d-flex justify-content-center align-items-center py-5">
                            <span className="spinner-border spinner-border-sm me-2 text-primary" />
                            <span className="text-muted">{t("Carregando...")}</span>
                        </div>
                    )}

                    {/* Estado vazio */}
                    {!loading && data.length === 0 && (
                        <div className="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                            <i className="fas fa-check-circle fa-3x mb-3" style={{ color: '#ccc' }} />
                            <p className="mb-0">{t("Nenhum lançamento conciliado encontrado")}</p>
                        </div>
                    )}

                    {/* Grupos de conciliação */}
                    {!loading && data.length > 0 && (
                        <InfiniteScroll
                            style={{ overflow: 'hidden' }}
                            dataLength={grupos.length}
                            next={() => loadData(grupos.length)}
                            hasMore={hasMore}
                            scrollableTarget={'scrollableDiv'}
                            loader={
                                <div className="d-flex justify-content-center align-items-center py-3">
                                    <span className="spinner-border spinner-border-sm me-2 text-primary" />
                                    <span className="text-muted">{t("Carregando mais...")}</span>
                                </div>
                            }
                            endMessage={
                                <p className="text-center text-muted mt-2 mb-1">
                                    <small><i className="fas fa-check me-1" />{t("Todos os lançamentos foram carregados")}</small>
                                </p>
                            }
                            refreshFunction={() => { }}
                            pullDownToRefresh
                            pullDownToRefreshThreshold={50}
                        >
                            {grupos.map((chaveVinculo) => {
                                const groupItems = data.filter(f => f.chaveVinculo === chaveVinculo);
                                const filteredItems = groupItems.filter(f =>
                                    isSalario ? !f.status.toLowerCase().includes('naocontem') : true
                                );

                                // DEVN3-638: na Hospedagem em Curso o grupo traz também as linhas do borderô
                                // do VHF (origem BORDERO). Débito/Crédito do rodapé seguem sendo só do razão;
                                // o borderô entra num total à parte.
                                const borderoItems = filteredItems.filter(f => f.origem === 'BORDERO');
                                const razaoItems = filteredItems.filter(f => f.origem !== 'BORDERO');
                                const temBordero = borderoItems.length > 0;
                                const borderoDebito = borderoItems
                                    .filter(f => f.tipoLancamento === 'D')
                                    .reduce((sum, f) => sum + (f.valorProvisaoRecolher ?? 0), 0);
                                const borderoCredito = borderoItems
                                    .filter(f => f.tipoLancamento === 'C')
                                    .reduce((sum, f) => sum + (f.valorProvisaoRecolher ?? 0), 0);

                                const totalDebito = razaoItems
                                    .filter(f => f.tipoLancamento === 'D')
                                    .reduce((sum, f) => sum + (f.valorProvisaoRecolher ?? 0), 0);
                                const totalCredito = razaoItems
                                    .filter(f => f.tipoLancamento === 'C')
                                    .reduce((sum, f) => sum + (f.valorProvisaoRecolher ?? 0), 0);
                                // Com borderô, a diferença do grupo é borderô × razão (débito e crédito);
                                // nos demais cartões continua sendo crédito × débito.
                                const diferenca = temBordero
                                    ? Math.round((Math.abs(borderoDebito - totalDebito) + Math.abs(borderoCredito - totalCredito)) * 100) / 100
                                    : Math.abs(totalCredito - totalDebito);

                                const totalArquivo = filteredItems
                                    .filter(f => f.status.toLowerCase().includes('excel'))
                                    .reduce((sum, f) => sum + (f.valorProvisaoRecolher ?? 0), 0);
                                const totalEcd = filteredItems
                                    .filter(f => !f.status.toLowerCase().includes('excel'))
                                    .reduce((sum, f) => sum + (f.valorProvisaoRecolher ?? 0), 0);
                                const temArquivo = isSalario && filteredItems.some(f => f.status.toLowerCase().includes('excel'));

                                const temDiferenca = diferenca > 0;

                                return (
                                    <div key={chaveVinculo} className="card mb-3 border-0 shadow-sm" style={{ borderRadius: 10, overflow: 'hidden' }}>

                                        {/* Cabeçalho do grupo */}
                                        <div
                                            className="card-header d-flex justify-content-between align-items-center py-2 px-3"
                                            style={{
                                                backgroundColor: temDiferenca ? '#fff8e1' : '#e8f5e9',
                                                borderLeft: `4px solid ${temDiferenca ? '#ffc107' : '#4caf50'}`,
                                                borderBottom: '1px solid rgba(0,0,0,.06)'
                                            }}
                                        >
                                            <div className="d-flex align-items-center gap-2">
                                                <i className={`fas ${temDiferenca ? 'fa-exclamation-triangle text-warning' : 'fa-link text-success'}`} />
                                                <code className="text-muted" style={{ fontSize: '0.72rem' }}>
                                                    {chaveVinculo.slice(0, 8)}…
                                                </code>
                                                <span className="badge rounded-pill bg-light text-dark border" style={{ fontSize: '0.72rem' }}>
                                                    {filteredItems.length} {t("itens")}
                                                </span>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => onClickDesvincular(chaveVinculo)}
                                                className="btn btn-sm btn-outline-danger"
                                                style={{ fontSize: '0.78rem' }}
                                            >
                                                <i className="fas fa-unlink me-1" />{t("Desvincular grupo")}
                                            </button>
                                        </div>

                                        {/* Tabela de lançamentos */}
                                        <div className="table-responsive">
                                            <table className="table table-sm table-hover mb-0 align-middle">
                                                <thead>
                                                    <tr style={{ backgroundColor: '#f8f9fa', fontSize: '0.78rem', textTransform: 'uppercase', color: '#6c757d' }}>
                                                        <th className="ps-3 fw-semibold">{t("Data")}</th>
                                                        <th className="fw-semibold">{t("Histórico")}</th>
                                                        <th className="text-center fw-semibold">{t("Tipo")}</th>
                                                        <th className="text-end fw-semibold pe-3">{t("Valor")}</th>
                                                        <th style={{ width: 36 }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredItems.map((item) => {
                                                        const isArquivo = item.status.toLowerCase().includes('excel');
                                                        const isDebito = item.tipoLancamento === 'D';
                                                        const isBordero = item.origem === 'BORDERO';
                                                        return (
                                                            <tr key={item.id}>
                                                                <td className="ps-3 text-nowrap" style={{ fontSize: '0.85rem' }}>
                                                                    {moment(item.dataLancamento).format('DD/MM/YYYY')}
                                                                </td>
                                                                <td style={{ maxWidth: 320, fontSize: '0.85rem' }}>
                                                                    <span title={item.historico} style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                        {item.historico}
                                                                    </span>
                                                                </td>
                                                                <td className="text-center">
                                                                    {isSalario && (
                                                                        <span className={`badge ${isArquivo ? 'bg-info' : 'bg-secondary'} text-white me-1`} style={{ fontSize: '0.72rem' }}>
                                                                            {isArquivo ? 'Arquivo' : 'ECD'}
                                                                        </span>
                                                                    )}
                                                                    {(isHospedagemEmCurso || temBordero) && (
                                                                        <span className={`badge ${isBordero ? 'bg-info' : 'bg-secondary'} text-white me-1`} style={{ fontSize: '0.72rem' }}>
                                                                            {isBordero ? t("Borderô") : t("Contabilidade")}
                                                                        </span>
                                                                    )}
                                                                    {(!isSalario || item.tipoLancamento === 'D' || item.tipoLancamento === 'C') && (
                                                                        <span className={`badge ${isDebito ? 'bg-primary' : 'bg-success'} text-white`} style={{ fontSize: '0.72rem' }}>
                                                                            {isDebito ? t("Débito") : t("Crédito")}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                                <td className="text-end pe-3 fw-semibold text-nowrap" style={{ fontSize: '0.85rem' }}>
                                                                    {(item.valorProvisaoRecolher ?? 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                                                </td>
                                                                <td className="pe-2">
                                                                    {/* Linha do borderô não é lançamento — só sai desvinculando o grupo. */}
                                                                    {!isBordero && (
                                                                        <button
                                                                            type="button"
                                                                            title={t("Desvincular item")}
                                                                            disabled={razaoItems.length <= 2}
                                                                            onClick={() => onClickDesvincularItem(item.chaveVinculo, item.id)}
                                                                            className="btn btn-sm btn-outline-danger p-1"
                                                                            style={{ lineHeight: 1, opacity: razaoItems.length <= 2 ? 0.35 : 1 }}
                                                                        >
                                                                            <i className="fas fa-times" style={{ fontSize: '0.7rem' }} />
                                                                        </button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Rodapé com totais */}
                                        <div
                                            className="card-footer d-flex flex-wrap gap-3 px-3 py-2"
                                            style={{ backgroundColor: '#fafafa', fontSize: '0.82rem', borderTop: '1px solid rgba(0,0,0,.06)' }}
                                        >
                                            {temArquivo && (
                                                <>
                                                    <span className="text-muted">
                                                        {t("Arquivo:")}&nbsp;
                                                        <strong>{totalArquivo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
                                                    </span>
                                                    <span className="text-muted">
                                                        {t("ECD:")}&nbsp;
                                                        <strong>{totalEcd.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
                                                    </span>
                                                </>
                                            )}
                                            {temBordero && (
                                                <span className="text-muted">
                                                    {t("Borderô:")}&nbsp;
                                                    <strong>D {borderoDebito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
                                                    &nbsp;&middot;&nbsp;
                                                    <strong>C {borderoCredito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
                                                </span>
                                            )}
                                            <span className="text-muted">
                                                {temBordero ? t("Contabilidade débito:") : t("Débito:")}&nbsp;
                                                <strong className="text-primary">{totalDebito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
                                            </span>
                                            <span className="text-muted">
                                                {temBordero ? t("Contabilidade crédito:") : t("Crédito:")}&nbsp;
                                                <strong className="text-success">{totalCredito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</strong>
                                            </span>
                                            <span className={diferenca === 0 ? 'text-success' : 'text-warning fw-bold'}>
                                                {t("Diferença:")}&nbsp;
                                                {diferenca.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                                {diferenca > 0 && <i className="fas fa-exclamation-triangle ms-1" />}
                                            </span>
                                        </div>
                                    </div>
                                );
                            })}

                            {/* Contador final */}
                            <div className="d-flex justify-content-end mt-1 mb-2">
                                <span className="badge bg-dark" style={{ fontSize: '0.78rem' }}>
                                    {t("Total:")} {grupos.length} {t("grupos")}
                                </span>
                            </div>
                        </InfiniteScroll>
                    )}
                </div>
            </div>
        </Modal>
    )
}

function ModalAlerta({ mensagens, show, toggleModal }: { mensagens: any[], show: boolean, toggleModal: Function }) {
    const { t } = useTranslation();
    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>{t("Alertas")}</h5>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-12">
                            {mensagens.map((item) => {
                                return <p style={{ fontSize: '14px' }}>{ReactHtmlParser(item.mensagem)}</p>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}


const ModalCard = ({ connection, mensagemSistema, mostrarContaReferencial, empresa, dataI, dataF, toggleModal, show, acc, reprocessar, updateAll, conciliacaoInteligente, processou, contas, updateDescription, esteira, conferencia, onConcluidoClick, showModal, onRequestExtratoBancario, onRequestFolhaPagamento, onSubmeterSox, soxStatus }: { connection: HubConnection, toggleModal: () => void, show: boolean, acc: IRelatorio | undefined, contas: IRelatorio[], reprocessar: any, conciliacaoInteligente: boolean | undefined, processou: boolean, updateDescription: Function, dataI: Date, dataF: Date, empresa: number, esteira: number, updateAll: Function, mensagemSistema: any[], conferencia: boolean, mostrarContaReferencial: boolean, onConcluidoClick: Function, showModal: Function, onRequestExtratoBancario?: (acc: IRelatorio) => void, onRequestFolhaPagamento?: (acc: IRelatorio) => void, onSubmeterSox?: () => void, soxStatus?: { submetido: boolean; concilId?: number; status?: string; etapaAtual?: string; nivelRisco?: string } }) => {

    const [modal, setModal] = useState<any>({
        show: false,
        acc: acc,
        status: null
    });

    const [modalConciliado, setModalConciliado] = useState<any>({
        show: false,
        acc: acc,
        status: null
    });

    const [modalContasConfirmacao, setModalContasConfirmacao] = useState<any>({
        show: false,
        acc: acc,
        status: null
    });

    // DEVN3-528: cartão com ao menos um alerta (ex.: conta virada) — usado para destacar o SALDO FINAL.
    const contaTemAlerta = !!acc && (mensagemSistema || []).some((f: any) => f.conta === acc.contaEmpresa);

    const [modalAlertas, setModalAlertas] = useState<any>({
        show: false
    });

    const [modalGerenciarLancamento, setModalGerenciarLancamentos] = useState<any>({
        show: false
    })

    const [modalConciliadoBancario, setModalConciliadoBancario] = useState<boolean>(false);
    const [modalConciliadoFolha, setModalConciliadoFolha] = useState<boolean>(false);
    const [modalIrrfFolhaAnalise, setModalIrrfFolhaAnalise] = useState<boolean>(false);
    const [modalEstoqueAnalise, setModalEstoqueAnalise] = useState<boolean>(false);
    const [modalFgtsAnalise, setModalFgtsAnalise] = useState<boolean>(false);
    const [modalSalarioLiquidoAnalise, setModalSalarioLiquidoAnalise] = useState<boolean>(false);

    const [showHistorico, setShowHistorico] = useState<boolean>(false);
    const [historicoData, setHistoricoData] = useState<any[]>([]);
    const [loadingHistorico, setLoadingHistorico] = useState<boolean>(false);
    const [showArquivos, setShowArquivos] = useState<boolean>(false);
    const [showDownloads, setShowDownloads] = useState<boolean>(false);
    const [contasParticipante, setContasParticipante] = useState<IContaParticipante[]>([]);
    const [carregandoContasParticipante, setCarregandoContasParticipante] = useState<boolean>(false);
    const [showContasParticipante, setShowContasParticipante] = useState<boolean>(false);

    const isProcessing = acc?.status === "Pendentes" || acc?.status === "Em processamento";

    const [loadingReport, setLoadingReport] = useState<boolean>(false);
    const [arquivosAnexadosAntesProcessar, setArquivosAnexadosAntesProcessar] = useState<IArquivoCardEsteira[]>([]);
    const [linhaConfig, setLinhaConfig] = useState<number>(1);
    const [mesConfig, setMesConfig] = useState<number>(1);
    const [anoConfig, setAnoConfig] = useState<number>(2023);
    const [tipoArquivoSalario, setTipoArquivoSalario] = useState<number>(1);
    const [tipoImportacaoSalario, setTipoImportacaoSalario] = useState<number>(1);
    const [colaboradorConfig, setColaboradorConfig] = useState<string>("A");
    const [proventoConfig, setProventoConfig] = useState<string>("B");
    const [descontoConfig, setDescontoConfig] = useState<string>("C");
    const { t } = useTranslation();
    const [dataColunaConfig, setDataColunaConfig] = useState<string>("A");
    const [valorColunaConfig, setValorColunaConfig] = useState<string>("B");
    const [historicoColunaConfig, setHistoricoColunaConfig] = useState<string>("C");
    const [tipoColunaConfig, setTipoColunaConfig] = useState<string>("D");
    const [tipoBanco, setTipoBanco] = useState<string>("");
    const [arquivosAnexados, setArquivoAnexados] = useState<IArquivoCard[]>([]);
    const [loadingFile, setLoadingFile] = useState<boolean>();
    const [loadingList, setLoadingList] = useState<boolean>();

    const [description, setDescription] = useState<string>(acc?.descricao || "");

    const getSistema = useCallback((type: number) => {
        if (type === 1) return "padrao";
        if (type === 2) return "dominio";
        if (type === 3) return "dominio-web";
        if (type === 3) return "contimatic";
        if (type === 4 || type === 5) return "mundial";
        if (type === 6) return "dominio-houer";
        if (type === 7) return "id-brasil";
        return "";
    }, []);

    const onChangeFile = useCallback(async (e: any) => {
        setLoadingFile(true);
        if (e.target.files !== null && e.target.files.length > 0) {
            const file = e.target.files[0] as File;

            if (acc?.isBanco) {
                if (!file.type.toLowerCase().includes("xls") || !file.type.toLowerCase().includes("ofx")) {
                    if (file.type.toLowerCase().includes("xls")) {
                        if (!dataColunaConfig || !valorColunaConfig || !historicoColunaConfig) {
                            Swal.fire({
                                text: t('Por favor preencha todas configurações necessárias para a configuração do arquivo excel.'),
                                timer: 3000,
                                icon: 'error',
                                showConfirmButton: false
                            });
                            return;
                        }
                    }
                } else {
                    Swal.fire({
                        text: t('Por favor para banco importe apenas arquivos excel ou ofx, caso seja um arquivo ofx e não esteja com a extensão, edite o nome do arquivo para nome.ofx'),
                        timer: 5000,
                        icon: 'error',
                        showConfirmButton: false
                    });
                    return;
                }
            }
            const s3 = new ReactS3Client(configBucket);
            const res = await s3.uploadFile(file);

            const result = await ArquivoEmpresaService.cadastrarArquivoCard({
                codigoContabil: acc?.contaEmpresa || '',
                esteiraID: esteira,
                nome: file.name,
                url: res.location,
                id: 0
            });

            setArquivosAnexadosAntesProcessar((old) => {
                const copy = [...old];
                copy.push({
                    esteiraId: esteira,
                    codigoContabil: acc?.contaEmpresa || '',
                    nome: file.name,
                    url: res.location,
                    id: result.id,
                    podeDeletar: true,
                    excelConfigLiquido: {
                        linha: linhaConfig ? linhaConfig.toString() : "0",
                        fornecedor: colaboradorConfig || "",
                        valor: valorColunaConfig || "",
                        mes: mesConfig || 0,
                        ano: anoConfig || 0,
                        sistema: getSistema(tipoImportacaoSalario),
                        tipoLiquido: tipoArquivoSalario === 1 ? "Liquido" : tipoArquivoSalario === 2 ? "Resumo" : "Configuracao"
                    },
                    lancamentoConfigExcel: {
                        data: dataColunaConfig,
                        valor: valorColunaConfig,
                        historico: historicoColunaConfig,
                        tipo: tipoColunaConfig,
                        banco: tipoBanco
                    },
                    excelConfigResumo: {
                        linha: linhaConfig ? linhaConfig.toString() : "1",
                        evento: colaboradorConfig || "",
                        provento: proventoConfig || "",
                        desconto: descontoConfig || "",
                        mes: mesConfig || 0,
                        ano: anoConfig || 0,
                        sistema: getSistema(tipoImportacaoSalario),
                        tipoLiquido: tipoArquivoSalario === 1 ? "Liquido" : tipoArquivoSalario === 2 ? "Resumo" : "Configuracao"
                    },
                    sistema: getSistema(tipoImportacaoSalario),
                    tipoLiquido: tipoArquivoSalario === 1 ? "Liquido" : tipoArquivoSalario === 2 ? "Resumo" : "Configuracao"
                });
                return copy;
            });
        }
        setLoadingFile(false);
    }, [acc, esteira, dataColunaConfig, getSistema, tipoImportacaoSalario, valorColunaConfig, tipoColunaConfig, linhaConfig, historicoColunaConfig, proventoConfig, descontoConfig, anoConfig, mesConfig, tipoArquivoSalario, colaboradorConfig, valorColunaConfig, tipoBanco]);

    useEffect(() => {
        if (!show) {
            setArquivosAnexadosAntesProcessar([]);
            setLoadingFile(false);
        }
    }, [show]);

    useEffect(() => {
        if (acc && esteira) {
            setLoadingFile(true);
            ArquivoEmpresaService.liscarArquivoCard(acc?.contaEmpresa || "", esteira).then((resp) => {
                setLoadingFile(false);
                setArquivoAnexados(resp);
            });

        }
    }, [acc, esteira]);

    useEffect(() => {
        if (show && acc?.contaEmpresa && esteira) {
            setCarregandoContasParticipante(true);
            cartaoNovaService.buscarContasParticipante(esteira, acc.contaEmpresa)
                .then((resp) => setContasParticipante(resp))
                .catch(() => setContasParticipante([]))
                .finally(() => setCarregandoContasParticipante(false));
        } else if (!show) {
            setContasParticipante([]);
            setShowContasParticipante(false);
        }
    }, [show, acc?.contaEmpresa, esteira]);

    useEffect(() => {
        let interval: any;
        if (showHistorico && acc?.id) {
            const fetchHistorico = () => {
                setLoadingHistorico(true);
                api.get(`Cartao/${acc.id}/operacoes`)
                    .then(res => {
                        setHistoricoData(res.data);
                        setLoadingHistorico(false);
                    })
                    .catch(err => {
                        console.error("Erro ao buscar histórico:", err);
                        setLoadingHistorico(false);
                    });
            };

            fetchHistorico();
            interval = setInterval(fetchHistorico, 15000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [showHistorico, acc?.id]);

    useEffect(() => {
        if (acc && acc.descricao) {
            setDescription(acc.descricao);
        } else {
            setDescription("");
        }
    }, [acc?.descricao]);

    return (
        <>
            <ModalAlerta mensagens={mensagemSistema.filter(f => f.conta === acc?.contaEmpresa)} show={modalAlertas.show} toggleModal={() => setModalAlertas({ show: false })} />
            <RelatorioDemonstracaoContasConciliadas id={acc?.id || 0} isSalario={acc?.isSalario || false} esteiraID={acc?.esteiraID || 0} show={modalConciliado.show} acc={modalConciliado.acc} toggleModal={() => {
                setModalConciliado({
                    show: false,
                    acc: acc,
                    status: null
                })
            }} />
            <RelatorioDemonstracaoContasConfirmacao id={acc?.id || 0} connection={connection} esteiraID={acc?.esteiraID || 0} show={modalContasConfirmacao.show} acc={modalContasConfirmacao.acc} toggleModal={() => {
                setModalContasConfirmacao({
                    show: false,
                    acc: acc,
                    status: null
                })
            }} onAceitarTodos={() => {
                updateAll(acc?.contaEmpresa, 'Em processamento');
                setModalContasConfirmacao({ show: false, acc: acc, status: null });
            }} onRecusarTodos={() => {
                setModalContasConfirmacao({ show: false, acc: acc, status: null });
            }} />
            <RelatorioDemonstracaoContas contas={contas} esteiraID={acc?.esteiraID || 0} show={modal.show} id={modal.acc?.id || 0} status={modal.status} toggleModal={() => {
                setModal({
                    show: false,
                    acc: acc,
                    status: null
                })
            }} />
            <ModalGerenciarLancamentos
                show={modalGerenciarLancamento.show}
                toggleModal={() => {
                    setModalGerenciarLancamentos({
                        show: false
                    });
                }}
                acc={acc?.contaEmpresa || ""}
                esteiraID={esteira}
            />
            {acc?.id && (
                <ModalDownloadsCartao
                    relatorioId={acc.id}
                    show={showDownloads}
                    toggleModal={() => setShowDownloads(false)}
                />
            )}
            <ModalConciliadoBancario
                show={modalConciliadoBancario}
                onHide={() => setModalConciliadoBancario(false)}
                cartaoId={acc?.id || 0}
            />
            <ModalConciliadoFolha
                show={modalConciliadoFolha}
                onHide={() => setModalConciliadoFolha(false)}
                cartaoId={acc?.id || 0}
            />
            <ModalIrrfFolhaAnalise
                show={modalIrrfFolhaAnalise}
                onHide={() => setModalIrrfFolhaAnalise(false)}
                esteiraId={esteira || 0}
            />
            <ModalEstoqueAnalise
                show={modalEstoqueAnalise}
                onHide={() => setModalEstoqueAnalise(false)}
                esteiraId={esteira || 0}
                contaEmpresa={acc?.contaEmpresa}
            />
            <ModalFgtsAnalise
                show={modalFgtsAnalise}
                onHide={() => setModalFgtsAnalise(false)}
                esteiraId={esteira || 0}
            />
            <ModalSalarioLiquidoAnalise
                show={modalSalarioLiquidoAnalise}
                onHide={() => setModalSalarioLiquidoAnalise(false)}
                esteiraId={esteira || 0}
                contaEmpresa={acc?.contaEmpresa || ''}
            />
            <Modal size='lg' centered={true} show={modal.show || modalConciliado.show || modalContasConfirmacao.show || modalGerenciarLancamento.show || showDownloads || modalConciliadoBancario || modalConciliadoFolha || modalIrrfFolhaAnalise || modalEstoqueAnalise || modalFgtsAnalise || modalSalarioLiquidoAnalise ? false : show} onHide={toggleModal}>
                <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                    <div className="modal-header">
                        <div>
                            <h5 className="modal-title titulo-modal">{acc?.contaEmpresa} - {acc?.descricaoEmpresa || acc?.descricaoReferencial}</h5>
                            <h5 className="modal-title titulo-modal" style={{ fontSize: '10px', color: 'gray' }}>{acc?.contaReferencial} - {acc?.descricaoReferencial}</h5>
                        </div>
                        <button
                            className="btn btn-sm btn-primary ms-auto me-2"
                            onClick={() => { setShowArquivos(v => !v); setShowHistorico(false); setShowContasParticipante(false); }}
                        >
                            <i className="fas fa-folder-open me-1" />
                            {showArquivos ? "Voltar" : "Arquivos"}
                        </button>
                        <button className="btn btn-sm me-2" style={{ backgroundColor: '#005E96', color: 'white' }} onClick={() => { setShowHistorico(v => !v); setShowArquivos(false); setShowContasParticipante(false); }}>
                            {showHistorico ? "Voltar" : "Histórico"}
                        </button>
                        {!carregandoContasParticipante && contasParticipante.length > 0 && (
                            <button
                                className="btn btn-sm btn-light-info me-2 d-flex align-items-center gap-1"
                                onClick={() => { setShowContasParticipante(v => !v); setShowArquivos(false); setShowHistorico(false); }}
                                title="Contas Participante vinculadas a este CNPJ"
                            >
                                <i className="fas fa-users" />
                                {showContasParticipante ? "Voltar" : `Contas de Participantes (${contasParticipante.length})`}
                            </button>
                        )}
                        {acc?.id && (
                            <button
                                className="btn btn-sm btn-light-danger me-2 d-flex align-items-center gap-1"
                                onClick={() => setShowDownloads(true)}
                                title="Downloads do cartão"
                            >
                                <i className="fas fa-download" />
                                Downloads
                            </button>
                        )}
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                        </div>
                    </div>
                    <div className="modal-body">
                        {showContasParticipante ? (
                            <div className="row">
                                <div className="col-md-12">
                                    <h6>{t("Contas de Participantes")}</h6>
                                    <p className="text-muted" style={{ fontSize: '12px' }}>
                                        {t("Este cartão consolida o saldo de mais de uma Conta Participante vinculada ao mesmo CNPJ.")}
                                    </p>
                                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        <table className="table table-sm table-hover align-middle">
                                            <thead className="table-light">
                                                <tr>
                                                    <th scope="col">{t("Conta")}</th>
                                                    <th scope="col">{t("Descrição")}</th>
                                                    <th scope="col" className="text-end">{t("Saldo Inicial")}</th>
                                                    <th scope="col" className="text-end">{t("Débito")}</th>
                                                    <th scope="col" className="text-end">{t("Crédito")}</th>
                                                    <th scope="col" className="text-end">{t("Saldo Final")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {contasParticipante.map((item) => (
                                                    <tr key={uniqueId()}>
                                                        <td>{item.contaParticipanteCodigo}</td>
                                                        <td>{item.descricaoParticipante}</td>
                                                        <td className="text-end">{item.saldoInicial.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                        <td className="text-end">{item.totalDebito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                        <td className="text-end">{item.totalCredito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                        <td className="text-end">{item.saldoFinal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        ) : showArquivos && acc?.id ? (
                            <div className="row">
                                <div className="col-md-12">
                                    <ArquivosCartao
                                        esteiraId={esteira}
                                        cartaoId={acc.id}
                                        onProcessou={() => acc?.contaEmpresa && updateAll(acc.contaEmpresa, "Em processamento")}
                                    />
                                </div>
                            </div>
                        ) : showHistorico ? (
                            <div className="row">
                                <div className="col-md-12">
                                    <h6>Histórico do Cartão</h6>
                                    {loadingHistorico && <div>Carregando...</div>}
                                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        {historicoData.map((item: any, index) => {
                                            let statusText = "Pendente";
                                            let statusColor = "gray";
                                            if (item.processando) {
                                                statusText = "Processando";
                                                statusColor = "blue";
                                            } else if (item.erro) {
                                                statusText = "Erro";
                                                statusColor = "red";
                                            } else if (item.processou) {
                                                statusText = "Concluído";
                                                statusColor = "green";
                                            }

                                            return (
                                                <div key={index} style={{ padding: '8px', borderBottom: '1px solid #ddd', backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <span style={{ fontWeight: 'bold' }}>{tipoOperacaoMap[item.tipo] || item.tipo}</span>
                                                        <span style={{
                                                            fontWeight: 'bold',
                                                            color: statusColor,
                                                            fontSize: '11px',
                                                            padding: '2px 6px',
                                                            borderRadius: '4px',
                                                            backgroundColor: `${statusColor}22`
                                                        }}>
                                                            {statusText.toUpperCase()}
                                                        </span>
                                                    </div>
                                                    <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
                                                        <span>Usuário: {item.usuarioNome ? item.usuarioNome.split(' ').slice(0, 2).join(' ') : 'Desconhecido'}</span>
                                                        <span style={{ float: 'right' }}>{moment(item.dataOperacao).format("DD/MM/YYYY HH:mm:ss")}</span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {historicoData.length === 0 && !loadingHistorico && (
                                            <div style={{ textAlign: 'center', padding: '20px', color: 'gray' }}>
                                                Nenhum histórico encontrado para este cartão.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className='col-md-12'>
                                            {acc && (
                                                <div className='row'>
                                                    <div className="col-md-6">
                                                        <p className="h6" style={{ color: 'gray' }}>{t("SALDO INICIAL: ")}</p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <p className="h6">{acc.saldoInicial.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} {acc.lancamentoInicial}</p>
                                                    </div>
                                                    <div className="col-md-6 mt-2">
                                                        <p className="h6" style={{ color: 'gray' }}>{t("MOVIMENTAÇÃO DÉBITO:")} </p>
                                                    </div>
                                                    <div className="col-md-6 mt-2">
                                                        <p className="h6">{acc.debito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                                                    </div>
                                                    <div className="col-md-6 mt-2">
                                                        <p className="h6" style={{ color: 'gray' }}>{t("MOVIMENTAÇÃO CRÉDITO:")} </p>
                                                    </div>
                                                    <div className="col-md-6 mt-2">
                                                        <p className="h6">{acc.credito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                                                    </div>
                                                    <div className="col-md-6 mt-2">
                                                        <p className="h6" style={{ color: (acc.erroSaldoFinal || contaTemAlerta) ? '#C0392B' : 'gray', fontWeight: (acc.erroSaldoFinal || contaTemAlerta) ? 'bold' : undefined }}>{t("SALDO FINAL:")} </p>
                                                    </div>
                                                    <div className="col-md-6 mt-2">
                                                        <p className="h6" style={{ color: (acc.erroSaldoFinal || contaTemAlerta) ? '#C0392B' : 'unset', fontWeight: (acc.erroSaldoFinal || contaTemAlerta) ? 'bold' : undefined }}>{acc.saldoFinalReal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} {acc.lancamento}</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-md-12 mt-6">
                                            <div className="form-group">
                                                <label className="h5">{t("Descrição")}</label>
                                                <textarea value={description} onChange={(e) => setDescription(e.target.value)} onBlur={() => updateDescription(description)} style={{ backgroundColor: 'transparent' }} className="form-control" placeholder={t("Adicione uma descrição")}></textarea>
                                            </div>
                                            {(acc?.isImobilizado || acc?.isSalario || acc?.isFolha) && acc?.id && (
                                                <AnexosCartao cartaoId={acc.id} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="col-md-12 mt-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                                            {loadingReport ? (
                                                <div className="spinner-border text-success" role="status" style={{ marginBottom: '5px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span className="sr-only">{t("Loading...")}</span>
                                                </div>
                                            ) : (
                                                <>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', opacity: isProcessing ? 0.5 : 1, cursor: isProcessing ? 'not-allowed' : 'pointer' }} onClick={(e) => {
                                                        if (isProcessing) return;
                                                        window.open(`/capa-conciliacao/${acc?.id}`, '_blank');
                                                    }}>
                                                        <i className='fa fa-eye fs-4' style={{ color: 'gray', fontSize: '24px' }} />
                                                        <p>{t("Visualizar")}</p>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', opacity: isProcessing ? 0.5 : 1, cursor: isProcessing ? 'not-allowed' : 'pointer' }} onClick={(e) => {
                                                        if (isProcessing) return;
                                                        setLoadingReport(true);
                                                        RelatoriosService.pegarUrlImpressaoNovo(empresa, [{
                                                            conta: acc?.contaEmpresa || '',
                                                            id: acc?.id || 0
                                                        }], mostrarContaReferencial, dataI, dataF, (x: Blob) => {
                                                            setLoadingReport(false);
                                                            window.open(URL.createObjectURL(x), '_blank');
                                                        });
                                                    }}>
                                                        <i className='fa fa-file-pdf fs-4' style={{ color: '#dc3545', fontSize: '24px' }} />
                                                        <p>{t("PDF")}</p>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        {/* Botão SOX — visível para contas Concluidas, Parcial ou Em Conferencia */}
                                        {(acc?.status === 'Concluida' || acc?.status === 'Conciliado Parcial' || acc?.status === 'Em Conferencia') && (
                                            <div className="col-md-12 mt-2" style={{ marginBottom: 8 }}>
                                                {soxStatus?.submetido ? (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8, fontSize: 13 }}>
                                                        <span style={{ color: '#16a34a' }}>&#x2713;</span>
                                                        <span style={{ color: '#15803d', fontWeight: 600 }}>Submetida para Aprovação SOX</span>
                                                        <span style={{ color: '#6b7280', fontSize: 12 }}>— {soxStatus.etapaAtual} · {soxStatus.nivelRisco}</span>
                                                    </div>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary w-100"
                                                        style={{ background: '#1d4ed8', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 13, color: '#fff', cursor: 'pointer' }}
                                                        onClick={onSubmeterSox}
                                                    >
                                                        &#9654; Submeter para Aprovação SOX
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                        {
                                            conferencia && (
                                                <div className="col-md-12 mt-2">
                                                    <button disabled={isProcessing} onClick={() => onConcluidoClick()} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{t("MOVER PARA CONCLUÍDO")}</button>
                                                </div>
                                            )
                                        }
                                        {
                                            conciliacaoInteligente && (
                                                <div className="col-md-12 mt-2">
                                                    <button disabled={isProcessing} onClick={toggleModal} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{t("CONCILIAÇÃO INTELIGENTE")}</button>
                                                </div>
                                            )
                                        }
                                        {
                                            reprocessar && (
                                                <div className="col-md-12 mt-2">
                                                    <button disabled={isProcessing} onClick={() => reprocessar(arquivosAnexadosAntesProcessar)} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{t("PROCESSAR")}</button>
                                                </div>
                                            )
                                        }

                                        {!(acc?.isBanco || acc?.isCaixa) && (
                                            <div className="col-md-12 mt-2">
                                                <button disabled={isProcessing} onClick={() => {
                                                    setModalAlertas({ show: true });
                                                }} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{t("ALERTAS")}</button>
                                            </div>
                                        )}
                                        {acc?.isIrrfFolha && processou && (
                                            <div className="col-md-12 mt-2">
                                                <button disabled={isProcessing} onClick={() => {
                                                    setModalIrrfFolhaAnalise(true);
                                                }} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{t("DETALHES DA CONCILIAÇÃO")}</button>
                                            </div>
                                        )}
                                        {acc?.isEstoque && processou && (
                                            <div className="col-md-12 mt-2">
                                                <button disabled={isProcessing} onClick={() => {
                                                    setModalEstoqueAnalise(true);
                                                }} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{t("DETALHES DA CONCILIAÇÃO")}</button>
                                            </div>
                                        )}
                                        {acc?.isFgts && processou && (
                                            <div className="col-md-12 mt-2">
                                                <button disabled={isProcessing} onClick={() => {
                                                    setModalFgtsAnalise(true);
                                                }} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{t("DETALHES DA CONCILIAÇÃO")}</button>
                                            </div>
                                        )}
                                        {acc?.isSalario && processou && (
                                            <div className="col-md-12 mt-2">
                                                <button disabled={isProcessing} onClick={() => {
                                                    setModalSalarioLiquidoAnalise(true);
                                                }} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{t("DETALHES DA CONCILIAÇÃO")}</button>
                                            </div>
                                        )}
                                        {acc && acc?.status && acc.status !== "Pendentes" && acc.status !== "Em processamento" && !acc?.isEstoque && (
                                            <div className="col-md-12 mt-2">
                                                <button onClick={() => {
                                                    if ((acc.isBanco || acc.isCaixa) && onRequestExtratoBancario) {
                                                        toggleModal();
                                                        onRequestExtratoBancario(acc);
                                                    } else if (acc.isFolha && onRequestFolhaPagamento) {
                                                        toggleModal();
                                                        onRequestFolhaPagamento(acc);
                                                    } else {
                                                        RelatoriosService.conciliar(esteira || 0, acc.id);
                                                        updateAll(acc.contaEmpresa, "Em processamento");
                                                        toggleModal();
                                                    }
                                                }} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{t("REPROCESSAR")}</button>
                                            </div>
                                        )}
                                        {
                                            processou ? Object.keys(statusObject).filter(item => {
                                                // DEVN3-469: estoque concilia automaticamente pelo pipeline de /integracao
                                                // (ver EstoqueConciliationService) — nenhum desses botões de match manual
                                                // se aplica (o "DETALHES DA CONCILIAÇÃO" acima já cobre o resultado).
                                                if (acc?.isEstoque) {
                                                    return !['possiveisMatch', 'erro', 'recomendacao', 'conciliacao', 'pendente', 'aviso', 'conciliado'].includes(item);
                                                }
                                                return !(acc?.isBanco || acc?.isCaixa || acc?.isFolha) || !['possiveisMatch', 'erro', 'recomendacao', 'conciliacao', 'aviso'].includes(item);
                                            }).map((item) => (
                                                <>
                                                    {item !== 'totalpendente' && item !== "conciliacao" ? (
                                                        <div className="col-md-12 mt-2" key={uniqueId()}>
                                                            <button onClick={() => {
                                                                if (item === 'conciliado') {
                                                                    if (acc?.isBanco || acc?.isCaixa) {
                                                                        setModalConciliadoBancario(true);
                                                                    } else if (acc?.isFolha) {
                                                                        setModalConciliadoFolha(true);
                                                                    } else {
                                                                        setModalConciliado({
                                                                            show: true,
                                                                            acc: acc,
                                                                            status: item
                                                                        });
                                                                    }
                                                                } else if (item === 'possiveisMatch') {
                                                                    setModalContasConfirmacao({
                                                                        show: true,
                                                                        acc: acc,
                                                                        status: item
                                                                    })
                                                                } else {
                                                                    setModal({
                                                                        show: true,
                                                                        acc: acc,
                                                                        status: item
                                                                    })
                                                                }
                                                            }} type="button" disabled={isProcessing} className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{statusObject[item]}</button>
                                                        </div>
                                                    ) : (
                                                        <div className="col-md-12 mt-2" key={uniqueId()}>
                                                            <button onClick={() => {
                                                                setModal({
                                                                    show: true,
                                                                    acc: acc,
                                                                    status: item
                                                                })
                                                            }} type="button" disabled={isProcessing} className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{statusObject[item]}</button>
                                                        </div>
                                                    )}
                                                </>
                                            )) : (
                                                <div className="spinner-border text-success" role="status" style={{ margin: '0 auto', marginTop: '20px' }}>
                                                    <span className="sr-only">{t("Loading...")}</span>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ModalCard;